import { useState } from "react";
import { authService } from "../../../services/api";


// import './index.css'
import './newcss.css'
import { useNotification } from "../../../components/Notifications/NotificationContext";
import PushTip from "../../../components/UI/PushTip/PushTip";

export default function CreateBot() {
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);

  const { showError, showSuccess, showInfo } = useNotification();


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let bot_id;

    try {
      /* 1️⃣ cria o bot */
      const { data: botData } = await authService.bots.create_bot({ token });

      bot_id = botData.bot_id;

      /* 3️⃣ Seleciona o novo bot na sidebar */
      localStorage.setItem("selectedBotId", String(bot_id));
      window.dispatchEvent(new CustomEvent('selectedBotChanged', { detail: bot_id }));

      showSuccess("Bot criado com sucesso! Redirecionando...");
      setTimeout(() => {
        window.location.href = `/bots/edit/${bot_id}`;
      }, 1500);
      return

      // redirect ou success
    } catch (err) {
      console.error(err);
      showError(`${err.response?.data?.error || "Erro ao criar bot. Verifique o token e tente novamente."}`);
      return
    } finally {
      setLoading(false);

    }
  };

  /* ---------------------------
     JSX
  ----------------------------*/

  return (
    <div className='page'>


      <header style={{ marginBottom: 24 }}>
        <h1 className='title'>Criar Novo Bot</h1>
        <p className='text-gray-400'>
          Configure seu bot Telegram para vendas automatizadas.
        </p>
      </header>

      <form className="spt-form-bot" onSubmit={handleSubmit}>

        {/* TOKEN */}
        <div className="mt-2">
          <label className="spt-label">Token do Bot <span className="required">*</span></label>
          <input
            value={token}
            onChange={(e) => setToken(e.target.value)}
            required
            className="input3"
            placeholder="123456789:123456789:AAHdqTcvCH1vGWJxfSeofSAs0K5PALDsaw"
          />
          <small className="form-hint">
            <span style={{ color: "#eab308" }}>
              <i className="fas fa-exclamation-triangle me-1"></i>Atenção:{" "}
            </span>
            Token obtido do @BotFather no Telegram
          </small>
        </div>


        <div className="flex justify-end">
          <button disabled={loading} className="btn-primary mt-2 align-end">
            {loading ? "Criando..." : <><i className="fas fa-plus"></i>Criar Bot</>}
          </button>
        </div>
      </form>
      <PushTip>
        Nunca compartilhe seu token com terceiros. Ele é a chave de acesso ao seu bot e pode ser usado para controlá-lo completamente. Se você acredita que seu token foi comprometido, gere um novo token no @BotFather imediatamente.
      </PushTip>
    </div>
  );
}
